import api from 'api'
import {
  ADVISOR_CLIENT_PLAN_SELECTED,
} from './types'

export const clientPlanSelected = plan => ({
  type: ADVISOR_CLIENT_PLAN_SELECTED,
  data: plan
})

export const selectPlan = id => dispatch =>
  api.bmc.advisor.selectPlan(id).then(res=>{
    sessionStorage.setItem('planId', res.id)
    dispatch(clientPlanSelected(res))
    return res
  })  

export const deletePlan = id => dispatch =>
  api.bmc.advisor.deletePlan(id).then(()=>{
    sessionStorage.setItem('planId', undefined)
    dispatch(clientPlanSelected(null))
  })
